/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cap_Money_BodyInputs */

const en_cap_money_body = /** @type {(inputs: Cap_Money_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The system finds companies that fit, researches each one, scores the fit and drafts the first message. A person approves what goes out.`)
};

const lv_cap_money_body = /** @type {(inputs: Cap_Money_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sistēma atrod atbilstošus uzņēmumus, izpēta katru, novērtē atbilstību un sagatavo pirmo ziņu. Ko nosūtīt, apstiprina cilvēks.`)
};

/**
* | output |
* | --- |
* | "The system finds companies that fit, researches each one, scores the fit and drafts the first message. A person approves what goes out." |
*
* @param {Cap_Money_BodyInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const cap_money_body = /** @type {((inputs?: Cap_Money_BodyInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cap_Money_BodyInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_cap_money_body(inputs)
	return en_cap_money_body(inputs)
});